const defaultProcessor = require('./default');

module.exports = function (eventName, eventData) {
  const $sticker = $('#' + eventData.id);

  if ($sticker.is('image')) {
    const deferred = $.Deferred();
    deferred.reject(new Error('Sticker create failed'));
    return deferred.promise();
  }

  return defaultProcessor.apply(this, arguments);
};
